import {LitElement, html, css} from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { navigator } from 'lit-element-router';
import {ifDefined} from 'lit/directives/if-defined.js';
import store from '../src/store';
import { forceRedraw, setTheme } from '../src/store';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { SldsBaseElement } from '../components/slds-base-element.js';

@customElement('slds-dropdown')
class SldsDropdown extends connect(store)(navigator(SldsBaseElement)) {
  @property({type: Boolean}) open = false;
  @property({type: Array}) options = [];
  @state() theme = 'light';

  stateChanged(state) {
    this.theme = state.theme;
  }

  constructor() {
    super();
    document.addEventListener('click', (function(e) {
      if (this.open) {
        const path = e.composedPath();
        let insideMenuClick = false;
        if(!(path === undefined || path.length == 0)) {
         insideMenuClick = path.find((el) => { return el == this; });
        }
        if(insideMenuClick) {
          //inside element
        } else {
          //outside element
          this.open = false;
          const event = new CustomEvent('blur', { detail: { open: this.open }, bubbles: true });
          this.dispatchEvent(event);
        }
      }
    }).bind(this), false);
  }

  checkboxChecked(e) {
    var theme = "light";
    const currentHour = new Date().getHours();
    const shouldBeLightAuto = currentHour >= 6 && currentHour < 20;
    
    if (e.target.checked) {
      theme = "dark";
      document.documentElement.classList.add('dark');
      document.documentElement.classList.remove('light');
      
      // If it would naturally be dark mode, remove preference
      if (!shouldBeLightAuto) {
        localStorage.removeItem("theme");
      } else {
        localStorage.setItem("theme", "dark");
      }
    }
    else {
      theme = "light";
      document.documentElement.classList.add('light');
      document.documentElement.classList.remove('dark');
      
      // If it would naturally be light mode, remove preference
      if (shouldBeLightAuto) {
        localStorage.removeItem("theme");
      } else {
        localStorage.setItem("theme", "light");
      }
    }
    document.body.click();
    setTimeout((function(){
      this.open = true;
    }).bind(this), 50);
    store.dispatch(forceRedraw());
    store.dispatch(setTheme(theme));
  }

  pickOption(e) {
    var target = e.target;
    var i = 0;
    while((!target.dataset.type && !target.dataset.href) && i<5) {
      target = target.parentElement;
      i++;
    }
    var type = target.dataset.type;
    this.open = false;
    const blur = new CustomEvent('blur', { detail: { open: this.open }, bubbles: true });
    this.dispatchEvent(blur);
    if (target.dataset.href) {
      this.navigate("/"+target.dataset.href);
      return;
    }
    const event = new CustomEvent('select', { detail: { type: type }, bubbles: true });
    this.dispatchEvent(event);
  }

  renderItem(item) {
    if (item.type === 'hr') {
      return html`<li class="slds-has-divider_top-space" role="separator"></li>`;
    }
    if (item.type === 'footer') {
      return html`<li class="slds-dropdown__item slds-p-top_xx-small slds-p-left_small" role="presentation" style="color: #c9c7c5;">${item.label}</li>`;
    }
    if (item.type === 'toggle') {
      return html`<li class="slds-dropdown__item" role="presentation">
        <div class="slds-form-element slds-p-left_small">
          <label class="slds-checkbox_toggle slds-grid">
            <span class="slds-form-element__label slds-m-bottom_none">${item.label}</span>
            <input type="checkbox" ?checked="${this.theme === 'dark'}" @change="${this.checkboxChecked}" name="darkmode" value="darkmode" aria-describedby="darkmode" />
            <span id="darkmode" class="slds-checkbox_faux_container slds-p-left_xx-large slds-m-left_xx-large" aria-live="assertive">
              <span class="slds-checkbox_faux"></span>
              <span class="slds-checkbox_on">Enabled</span>
              <span class="slds-checkbox_off">Disabled</span>
            </span>
          </label>
        </div>
      </li>`;
    }
    if (item.type === 'header') {
      return html`<li class="slds-dropdown__header slds-truncate" title="${item.label}" role="separator">
        <span>${item.label}</span>
      </li>`;
    }
    return html`<li class="slds-dropdown__item" role="presentation"><a href="javascript:void(0);" data-type="${item.value}" data-href="${item.href}" @click="${this.pickOption}" role="menuitem"><span class="slds-truncate" title="${item.value}">${item.label}</span></a></li>`;
    // ... other cases from the previous implementation ...
  }

  static styles = [
    super.styles,
    css`
      slot {
        display: inline-block;
      }
      .dark .slds-has-divider--top-space, .dark .slds-has-divider_top-space {
        border-top: 1px solid #514f4d;
      }
      .dark .slds-form-element__label, .dark .slds-checkbox_faux_container>span {
        color: white;
      }
      .slds-dropdown {
        background: var(--background-color, #fff);
        color: var(--text-color, #181818);
        border: 1px solid var(--border-color, #e5e5e5);
      }
      .slds-dropdown__item>a {
        color: var(--text-color, #181818);
      }
      .slds-dropdown__item>a:focus, .slds-dropdown__item>a:hover {
        background-color: var(--table-hover, #f3f3f3);
      }
      .slds-dropdown__item span {
        color: var(--text-color, #181818);
      }
      .slds-has-divider--top-space, .slds-has-divider_top-space {
        border-top: 1px solid var(--border-color, #e5e5e5);
      }
    `
  ];

  render() {
    return html`
    <div class="slds-builder-header__nav-item">
      <div class="slds-dropdown-trigger slds-dropdown-trigger_click ${this.open?' slds-is-open':''}">
        <slot></slot>
        <div class="slds-dropdown slds-dropdown_small slds-dropdown_right">
          <ul class="slds-dropdown__list" role="menu" aria-label="Show More">
            ${this.options.map((item) => this.renderItem(item))}
          </ul>
        </div>
      </div>
    </div>
    `
  }
}